import { Modal } from "ui/Modal"
import { Flex, Button } from "antd"
import { Text, Title } from "ui/Typography"
import { useTranslation } from "react-i18next"
import WarningOutlinedWithBg from "ui/WarningOutlinedWithBg"
import { useDevice } from "hooks/useDevice"
import CustomDrawer from "ui/Drawer"
import PropTypes from "prop-types"

const DeleteModal = ({ loading, deleteModalOpen, setDeleteModalOpen, handleDeleteCancel, handleDeleteConfirm }) => {
  const { t } = useTranslation()
  const { isMobile } = useDevice()
  if (loading) return null
  return (
    <>
      {isMobile ? (
        <CustomDrawer
          open={deleteModalOpen}
          setOpen={setDeleteModalOpen}
          title={
            <Flex justify="space-between" align="center">
              <div className="flex-1 text-center">
                <WarningOutlinedWithBg />
              </div>
            </Flex>
          }
        >
          <Flex vertical gap={24}>
            <Flex vertical gap={16}>
              <Title level={3}>{t("global.delete_note", "Delete Note")}</Title>
              <Text>{t("global.delete_note_confirm", "Are you sure you want to delete note?")}</Text>
            </Flex>
            <Flex gap={12}>
              <Button variant="outlined" color="primary" onClick={handleDeleteCancel}>
                {t("global.cancel")}
              </Button>
              <Button type="primary" danger onClick={handleDeleteConfirm}>
                {t("global.delete", "Delete")}
              </Button>
            </Flex>
          </Flex>
        </CustomDrawer>
      ) : (
        <Modal
          centered
          open={deleteModalOpen}
          onCancel={handleDeleteCancel}
          width={430}
          title={
            <Flex justify="space-between" align="center">
              <div className="flex-1 text-center">
                <WarningOutlinedWithBg />
              </div>
            </Flex>
          }
        >
          <Flex vertical gap={24}>
            <Flex vertical gap={16}>
              <Title level={3}>{t("global.delete_note", "Delete Note")}</Title>
              <Text>{t("global.delete_note_confirm", "Are you sure you want to delete note?")}</Text>
            </Flex>
            <Flex gap={12}>
              <Button variant="outlined" color="primary" onClick={handleDeleteCancel}>
                {t("global.cancel")}
              </Button>
              <Button type="primary" danger onClick={handleDeleteConfirm}>
                {t("global.delete", "Delete")}
              </Button>
            </Flex>
          </Flex>
        </Modal>
      )}
    </>
  )
}

DeleteModal.propTypes = {
  loading: PropTypes.bool,
  deleteModalOpen: PropTypes.bool,
  setDeleteModalOpen: PropTypes.func,
  handleDeleteCancel: PropTypes.func,
  handleDeleteConfirm: PropTypes.func
}

export default DeleteModal
